/**
 * A bill is cancelled if either `status` or `paymentStatus` says so. Cancellation wins over
 * every other state, so a cancelled bill never reads as paid/completed/active.
 */
export function isCancelledBill(bill: any): boolean {
  return bill?.status === 'cancelled' || bill?.paymentStatus === 'cancelled'
}

/** Whether a bill counts towards revenue: settled (not active) and not cancelled. */
export function isRevenueBill(bill: any): boolean {
  return bill?.status !== 'active' && !isCancelledBill(bill)
}

export function getBillStatusLabel(bill: any): string {
  if (isCancelledBill(bill)) return 'cancelled'
  return bill?.status || bill?.paymentStatus || 'Unknown'
}

export function getBillStatusVariant(bill: any): 'default' | 'destructive' | 'secondary' {
  if (isCancelledBill(bill)) return 'destructive'
  if (bill?.status === 'completed' || bill?.paymentStatus === 'completed' || bill?.status === 'paid') return 'default'
  return 'secondary'
}
